export const ADD_TO_CART = 'ADD_TO_CART';
export const SET_CATEGORY = 'SET_CATEGORY';
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const EMPTY_CART = "EMPTY_CART";
export const SET_ORDER = "SET_ORDER";